import { useTranslation } from 'react-i18next'

import { EID } from '@/lib/element-ids.registry'

const AUDIT_CREDITS = 300

export function ListingCreditHint() {
  const { t } = useTranslation()

  return (
    <div
      id={EID['listing-builder-credit-hint']}
      className="flex items-center justify-end gap-1.5 text-xs text-neutral-500 dark:text-neutral-400"
    >
      <span className="inline-block h-1.5 w-1.5 rounded-full bg-orange-500" aria-hidden="true" />
      {t('listingBuilder.source.creditHint', { credits: AUDIT_CREDITS })}
    </div>
  )
}
